import type { FC } from 'react'

import React from 'react'
interface ITableMenu {
  children: React.ReactNode
}

const TableMenu: FC<ITableMenu> = ({ children }) => {
  return <div className='gridmenu'>{children}</div>
}

export default TableMenu
